/**
 * Created by bcole on 10/11/17.
 */
import React from 'react'

export default class IconNotebook extends React.Component {

    render() {

        return (
            <svg id="icon-notebook" viewBox="0 0 32 32" fill="currentColor" className={this.props.className}>
                <title>notebook</title>
                <path d="M5 18h2v1h-2v-1z"></path>
                <path d="M5 26h2v1h-2v-1z"></path>
                <path d="M5 22h2v1h-2v-1z"></path>
                <path d="M5 14h2v1h-2v-1z"></path>
                <path d="M5 10h2v1h-2v-1z"></path>
                <path d="M5 6h2v1h-2v-1z"></path>
                <path d="M13 9h7v3h-7v-3z"></path>
                <path
                    d="M24.003 3h-15.006c-1.103 0-1.997 0.897-1.997 2.006v0.994h2v1h-2v3h2v1h-2v3h2v1h-2v3h2v1h-2v3h2v1h-2v3h2v1h-2v0.994c0 1.109 0.891 2.006 1.997 2.006h15.006c1.103 0 1.997-0.897 1.997-2.006v-22.988c0-1.106-0.891-2.006-1.997-2.006zM21 13h-9v-5h9v5z"></path>
            </svg>
        )
    }
}